import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import CareerMentorshipAdminComponent from '../../../Components/AdminComponents/CareerMentorship';
import {
  editCareerMentorship,
  getCareerMentorship,
} from '../../../Store/Actions/careerMentorship';

const CareerMentorshipAdminContainer = () => {
  const dispatch = useDispatch();
  const [editData, setEditData] = useState();
  const {allCareerMentorships} = useSelector(
    ({careerMentorship}) => careerMentorship,
  );

  useEffect(() => {
    if (
      allCareerMentorships &&
      allCareerMentorships?.data?.career_mentorship &&
      allCareerMentorships?.data?.career_mentorship[0]
    ) {
      setEditData(allCareerMentorships?.data?.career_mentorship[0]);
    }
  }, [allCareerMentorships]);

  useEffect(() => {
    getCareerMentorshipData();
  }, []);

  const updateCareerMentorship = (Data, id) => {
    dispatch(editCareerMentorship(Data, id));
  };

  const getCareerMentorshipData = () => {
    const showMessage = true;
    dispatch(getCareerMentorship(showMessage));
  };
  return (
    <CareerMentorshipAdminComponent
      updateCareerMentorship={(id, Data) => {
        updateCareerMentorship(id, Data);
      }}
      EditData={editData}
    />
  );
};

export default CareerMentorshipAdminContainer;
